import { render, staticRenderFns } from "./duvidas.vue?vue&type=template&id=487fb272&"
import script from "./duvidas.vue?vue&type=script&lang=js&"
export * from "./duvidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports